<template>
  <v-snackbar v-model="toast" bottom fixed style="z-index:100" :timeout="-1">
    {{ text }}

    <template v-slot:action="{ attrs }">
      <v-btn
        color="light-green accent-4"
        @click="toast = false"
        text
        v-bind="attrs"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    toast: false,
    text: null
  }),
  methods: {
    open(title) {
      this.text = title;
      this.toast = true;
    },
    close() {
      this.toast = false;
      this.text = null;
    }
  }
};
</script>
